import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "header-content" };
const _hoisted_2 = { class: "contents-sub-title-text d-flex align-center justify-space-between" };
const _hoisted_3 = { key: 0 };
const _hoisted_4 = { key: 1 };
const _hoisted_5 = {
    key: 0,
    class: "business-info"
};
const _hoisted_6 = { class: "header-content" };
const _hoisted_7 = { class: "header-content" };
const _hoisted_8 = { class: "header-content" };
const _hoisted_9 = { class: "header-content" };
const _hoisted_10 = { class: "header-content" };
const _hoisted_11 = ["title"];
const _hoisted_12 = { class: "header-content" };
const _hoisted_13 = { class: "header-content" };
const _hoisted_14 = { class: "header-content" };
const _hoisted_15 = { class: "header-content" };
const _hoisted_16 = { class: "header-content" };
const _hoisted_17 = {
    key: 1,
    class: "business-info"
};
const _hoisted_18 = { class: "header-content" };
const _hoisted_19 = { class: "header-content" };
const _hoisted_20 = { class: "header-content" };
const _hoisted_21 = { class: "brg-input-section" };
const _hoisted_22 = { class: "header-content" };
const _hoisted_23 = { class: "brg-input-section" };
const _hoisted_24 = { class: "header-content" };
const _hoisted_25 = { class: "brg-input-section address" };
const _hoisted_26 = { ref: "postcodeDialogRef" };
const _hoisted_27 = { class: "header-content" };
const _hoisted_28 = { class: "brg-input-section" };
const _hoisted_29 = { class: "header-content" };
const _hoisted_30 = { class: "brg-input-section" };
const _hoisted_31 = { class: "header-content" };
const _hoisted_32 = { class: "brg-input-section" };
const _hoisted_33 = { class: "header-content" };
const _hoisted_34 = { class: "brg-input-section" };
const _hoisted_35 = { class: "header-content" };
const _hoisted_36 = { class: "brg-input-section" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_btn = _resolveComponent("v-btn");
    const _component_v_text_field = _resolveComponent("v-text-field");
    const _component_v_col = _resolveComponent("v-col");
    const _component_v_icon = _resolveComponent("v-icon");
    const _component_DialogHeader = _resolveComponent("DialogHeader");
    const _component_v_card = _resolveComponent("v-card");
    const _component_v_dialog = _resolveComponent("v-dialog");
    const _component_v_row = _resolveComponent("v-row");
    const _component_v_table = _resolveComponent("v-table");
    const _directive_btn_style = _resolveDirective("btn-style");
    return (_ctx.taxInvoiceData)
        ? (_openBlock(), _createBlock(_component_v_table, {
            key: 0,
            class: "content-table"
        }, {
            default: _withCtx(() => [
                _createElementVNode("thead", _hoisted_1, [
                    _createElementVNode("tr", null, [
                        _cache[9] || (_cache[9] = _createElementVNode("th", null, null, -1 /* CACHED */)),
                        _createElementVNode("th", _hoisted_2, [
                            _createTextVNode(_toDisplayString(_ctx.localeInfo.invoicer) + " ", 1 /* TEXT */),
                            _createCommentVNode(" 발행 권한이 없으면 수정 할 수 없다 (UI 미노출) "),
                            _createCommentVNode(" 발행요청 전 상태가 아니면 수정 할 수 없다. "),
                            _withDirectives(_createElementVNode("div", null, [
                                (!_ctx.isEditMode)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                        _createCommentVNode(" 수정 "),
                                        _createCommentVNode(" 발행요청 전 상태가 아니면 수정 할 수 없다. (display 값 임의 수정 시 버튼 disabled) "),
                                        _createVNode(_component_v_btn, {
                                            class: "brg-btn primary size-s",
                                            disablied: _ctx.isModifyDisabled,
                                            onClick: _ctx.handleClickModifyBtn
                                        }, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.localeInfo.modify), 1 /* TEXT */)
                                            ]),
                                            _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["disablied", "onClick"])
                                    ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                        _createCommentVNode(" 적용 "),
                                        _createVNode(_component_v_btn, {
                                            class: "brg-btn primary size-s",
                                            onClick: _ctx.handleClickApplyModifyBtn
                                        }, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.localeInfo.apply), 1 /* TEXT */)
                                            ]),
                                            _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["onClick"]),
                                        _createCommentVNode(" 취소 "),
                                        _createVNode(_component_v_btn, {
                                            class: "brg-btn info outlined size-s ml-2",
                                            onClick: _ctx.handleClickCancelModifyBtn
                                        }, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.localeInfo.cancel), 1 /* TEXT */)
                                            ]),
                                            _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["onClick"])
                                    ]))
                            ], 512 /* NEED_PATCH */), [
                                [_vShow, !_ctx.isModifyDisabled]
                            ])
                        ])
                    ])
                ]),
                (!_ctx.isEditMode)
                    ? (_openBlock(), _createElementBlock("tbody", _hoisted_5, [
                        _createCommentVNode(" 등록번호(사업자번호) "),
                        _createElementVNode("tr", null, [
                            _createElementVNode("td", _hoisted_6, _toDisplayString(_ctx.localeInfo.businessNumber), 1 /* TEXT */),
                            _createElementVNode("td", null, _toDisplayString(_ctx.taxInvoiceData.formattedInvoicerBusinessNumber), 1 /* TEXT */)
                        ]),
                        _createCommentVNode(" 종사업장 "),
                        _createElementVNode("tr", null, [
                            _createElementVNode("td", _hoisted_7, _toDisplayString(_ctx.localeInfo.subBusinessName), 1 /* TEXT */),
                            _createElementVNode("td", null, _toDisplayString(_ctx.taxInvoiceData.formattedInvoicerSubBusinessName), 1 /* TEXT */)
                        ]),
                        _createCommentVNode(" 상호 "),
                        _createElementVNode("tr", null, [
                            _createElementVNode("td", _hoisted_8, _toDisplayString(_ctx.localeInfo.businessName), 1 /* TEXT */),
                            _createElementVNode("td", null, _toDisplayString(_ctx.taxInvoiceData.formattedInvoicerBusinessName), 1 /* TEXT */)
                        ]),
                        _createCommentVNode(" 성명(대표자명) "),
                        _createElementVNode("tr", null, [
                            _createElementVNode("td", _hoisted_9, _toDisplayString(_ctx.localeInfo.ceoName), 1 /* TEXT */),
                            _createElementVNode("td", null, _toDisplayString(_ctx.taxInvoiceData.formattedInvoicerCeoName), 1 /* TEXT */)
                        ]),
                        _createCommentVNode(" 사업장 주소 "),
                        _createElementVNode("tr", null, [
                            _createElementVNode("td", _hoisted_10, _toDisplayString(_ctx.localeInfo.businessAddress), 1 /* TEXT */),
                            _createElementVNode("td", {
                                class: "address",
                                title: _ctx.taxInvoiceData.formattedInvoicerAddress
                            }, _toDisplayString(_ctx.taxInvoiceData.formattedInvoicerAddress), 9 /* TEXT, PROPS */, _hoisted_11)
                        ]),
                        _createCommentVNode(" 업태 "),
                        _createElementVNode("tr", null, [
                            _createElementVNode("td", _hoisted_12, _toDisplayString(_ctx.localeInfo.businessCondition), 1 /* TEXT */),
                            _createElementVNode("td", null, _toDisplayString(_ctx.taxInvoiceData.formattedInvoicerBusinessCondition), 1 /* TEXT */)
                        ]),
                        _createCommentVNode(" 종목 "),
                        _createElementVNode("tr", null, [
                            _createElementVNode("td", _hoisted_13, _toDisplayString(_ctx.localeInfo.businessType), 1 /* TEXT */),
                            _createElementVNode("td", null, _toDisplayString(_ctx.taxInvoiceData.formattedInvoicerBusinessType), 1 /* TEXT */)
                        ]),
                        _createCommentVNode(" 담당자 "),
                        _createElementVNode("tr", null, [
                            _createElementVNode("td", _hoisted_14, _toDisplayString(_ctx.localeInfo.businessManager), 1 /* TEXT */),
                            _createElementVNode("td", null, _toDisplayString(_ctx.taxInvoiceData.formattedInvoicerContectInfo.name), 1 /* TEXT */)
                        ]),
                        _createCommentVNode(" 연락처 "),
                        _createElementVNode("tr", null, [
                            _createElementVNode("td", _hoisted_15, _toDisplayString(_ctx.localeInfo.businessPhone), 1 /* TEXT */),
                            _createElementVNode("td", null, _toDisplayString(_ctx.taxInvoiceData.formattedInvoicerContectInfo.telephone), 1 /* TEXT */)
                        ]),
                        _createCommentVNode(" 이메일 "),
                        _createElementVNode("tr", null, [
                            _createElementVNode("td", _hoisted_16, _toDisplayString(_ctx.localeInfo.businessEmail), 1 /* TEXT */),
                            _createElementVNode("td", null, _toDisplayString(_ctx.taxInvoiceData.formattedInvoicerContectInfo.email), 1 /* TEXT */)
                        ])
                    ]))
                    : (_openBlock(), _createElementBlock("tbody", _hoisted_17, [
                        _createCommentVNode(" 등록번호(사업자번호) "),
                        _createElementVNode("tr", null, [
                            _createElementVNode("td", _hoisted_18, _toDisplayString(_ctx.localeInfo.businessNumber), 1 /* TEXT */),
                            _createElementVNode("td", null, _toDisplayString(_ctx.taxInvoiceData.formattedInvoicerBusinessNumber), 1 /* TEXT */)
                        ]),
                        _createCommentVNode(" 종사업장 "),
                        _createElementVNode("tr", null, [
                            _createElementVNode("td", _hoisted_19, _toDisplayString(_ctx.localeInfo.subBusinessName), 1 /* TEXT */),
                            _createElementVNode("td", null, _toDisplayString(_ctx.taxInvoiceData.formattedInvoicerSubBusinessName), 1 /* TEXT */)
                        ]),
                        _createCommentVNode(" 상호 "),
                        _createElementVNode("tr", null, [
                            _createElementVNode("td", _hoisted_20, [
                                _createTextVNode(_toDisplayString(_ctx.localeInfo.businessName) + " ", 1 /* TEXT */),
                                _cache[10] || (_cache[10] = _createElementVNode("span", { class: "text-red" }, "*", -1 /* CACHED */))
                            ]),
                            _createElementVNode("td", _hoisted_21, [
                                _createVNode(_component_v_text_field, {
                                    ref: _ctx.formRefs.businessName,
                                    modelValue: _ctx.computedBusinessName,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.computedBusinessName) = $event)),
                                    maxlength: _ctx.HUB_ADJUSTMENT_TAX_INVOICE_FIELD,
                                    variant: "outlined",
                                    placeholder: _ctx.localeInfo.businessNamePlaceholder,
                                    "hide-details": "",
                                    rules: _ctx.formRule.isRequired.value
                                }, null, 8 /* PROPS */, ["modelValue", "maxlength", "placeholder", "rules"])
                            ])
                        ]),
                        _createCommentVNode(" 성명(대표자명) "),
                        _createElementVNode("tr", null, [
                            _createElementVNode("td", _hoisted_22, [
                                _createTextVNode(_toDisplayString(_ctx.localeInfo.ceoName) + " ", 1 /* TEXT */),
                                _cache[11] || (_cache[11] = _createElementVNode("span", { class: "text-red" }, "*", -1 /* CACHED */))
                            ]),
                            _createElementVNode("td", _hoisted_23, [
                                _createVNode(_component_v_text_field, {
                                    ref: _ctx.formRefs.ceoName,
                                    modelValue: _ctx.computedCeoName,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.computedCeoName) = $event)),
                                    maxlength: _ctx.HUB_ADJUSTMENT_TAX_INVOICE_FIELD,
                                    variant: "outlined",
                                    placeholder: _ctx.localeInfo.ceoNamePlaceholder,
                                    "hide-details": "",
                                    rules: _ctx.formRule.isRequired.value
                                }, null, 8 /* PROPS */, ["modelValue", "maxlength", "placeholder", "rules"])
                            ])
                        ]),
                        _createCommentVNode(" 사업장 주소 "),
                        _createElementVNode("tr", null, [
                            _createElementVNode("td", _hoisted_24, [
                                _createTextVNode(_toDisplayString(_ctx.localeInfo.businessAddress) + " ", 1 /* TEXT */),
                                _cache[12] || (_cache[12] = _createElementVNode("span", { class: "text-red" }, "*", -1 /* CACHED */))
                            ]),
                            _createElementVNode("td", _hoisted_25, [
                                _createVNode(_component_v_row, {
                                    class: "justify-space-between",
                                    "no-gutters": ""
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_v_col, { cols: "7" }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_v_text_field, {
                                                    ref: _ctx.formRefs.address,
                                                    "model-value": _ctx.getterInvoicerFormDataAddress,
                                                    class: "address-text-field mb-1",
                                                    variant: "outlined",
                                                    "hide-details": "",
                                                    rules: _ctx.formRule.isRequired.value
                                                }, null, 8 /* PROPS */, ["model-value", "rules"])
                                            ]),
                                            _: 1 /* STABLE */
                                        }),
                                        _createVNode(_component_v_col, {
                                            cols: "auto",
                                            class: "text-end"
                                        }, {
                                            default: _withCtx(() => [
                                                _createCommentVNode(" 주소 검색 다이얼로그 엑티베이터 "),
                                                _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                                                    "hide-details": "auto",
                                                    class: "ml-2",
                                                    onClick: _ctx.handleClickSearchPostCodeBtn
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_v_icon, {
                                                            small: "",
                                                            class: "pr-1"
                                                        }, {
                                                            default: _withCtx(() => _cache[13] || (_cache[13] = [
                                                                _createTextVNode(" mdi-magnify ")
                                                            ])),
                                                            _: 1 /* STABLE */,
                                                            __: [13]
                                                        }),
                                                        _createElementVNode("span", null, _toDisplayString(_ctx.localeInfo.searchPostCode), 1 /* TEXT */)
                                                    ]),
                                                    _: 1 /* STABLE */
                                                }, 8 /* PROPS */, ["onClick"])), [
                                                    [
                                                        _directive_btn_style,
                                                        void 0,
                                                        "config",
                                                        {
                                                            info: true,
                                                            outlined: true,
                                                            large: true,
                                                            "size-l": true
                                                        }
                                                    ]
                                                ])
                                            ]),
                                            _: 1 /* STABLE */
                                        }),
                                        _createCommentVNode(" 주소 검색 다이얼로그 "),
                                        _createVNode(_component_v_dialog, {
                                            modelValue: _ctx.isPostcodeDialogOpen,
                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.isPostcodeDialogOpen) = $event)),
                                            "content-class": "responsive-dialog"
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_v_card, null, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_DialogHeader, {
                                                            title: _ctx.localeInfo.searchPostCode,
                                                            "on-cancel": _ctx.handleClickCancelSearchPostCodeBtn
                                                        }, null, 8 /* PROPS */, ["title", "on-cancel"]),
                                                        _createElementVNode("div", _hoisted_26, null, 512 /* NEED_PATCH */)
                                                    ]),
                                                    _: 1 /* STABLE */
                                                })
                                            ]),
                                            _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["modelValue"])
                                    ]),
                                    _: 1 /* STABLE */
                                }),
                                _createCommentVNode(" 상세주소 "),
                                _createVNode(_component_v_text_field, {
                                    modelValue: _ctx.computedDetailAddress,
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.computedDetailAddress) = $event)),
                                    maxlength: _ctx.HUB_ADJUSTMENT_TAX_INVOICE_FIELD,
                                    placeholder: _ctx.localeInfo.detailAddressPlaceholder,
                                    variant: "outlined",
                                    "hide-details": ""
                                }, null, 8 /* PROPS */, ["modelValue", "maxlength", "placeholder"])
                            ])
                        ]),
                        _createCommentVNode(" 업태 "),
                        _createElementVNode("tr", null, [
                            _createElementVNode("td", _hoisted_27, _toDisplayString(_ctx.localeInfo.businessCondition), 1 /* TEXT */),
                            _createElementVNode("td", _hoisted_28, [
                                _createVNode(_component_v_text_field, {
                                    modelValue: _ctx.computedBusinessCondition,
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.computedBusinessCondition) = $event)),
                                    maxlength: _ctx.HUB_ADJUSTMENT_TAX_INVOICE_FIELD,
                                    variant: "outlined",
                                    placeholder: _ctx.localeInfo.businessConditionPlaceholder,
                                    "hide-details": ""
                                }, null, 8 /* PROPS */, ["modelValue", "maxlength", "placeholder"])
                            ])
                        ]),
                        _createCommentVNode(" 종목 "),
                        _createElementVNode("tr", null, [
                            _createElementVNode("td", _hoisted_29, _toDisplayString(_ctx.localeInfo.businessType), 1 /* TEXT */),
                            _createElementVNode("td", _hoisted_30, [
                                _createVNode(_component_v_text_field, {
                                    modelValue: _ctx.computedBusinessType,
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.computedBusinessType) = $event)),
                                    maxlength: _ctx.HUB_ADJUSTMENT_TAX_INVOICE_FIELD,
                                    variant: "outlined",
                                    placeholder: _ctx.localeInfo.businessTypePlaceholder,
                                    "hide-details": ""
                                }, null, 8 /* PROPS */, ["modelValue", "maxlength", "placeholder"])
                            ])
                        ]),
                        _createCommentVNode(" 담당자 "),
                        _createElementVNode("tr", null, [
                            _createElementVNode("td", _hoisted_31, _toDisplayString(_ctx.localeInfo.businessManager), 1 /* TEXT */),
                            _createElementVNode("td", _hoisted_32, [
                                _createVNode(_component_v_text_field, {
                                    modelValue: _ctx.computedContactName,
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.computedContactName) = $event)),
                                    maxlength: _ctx.HUB_ADJUSTMENT_TAX_INVOICE_FIELD,
                                    variant: "outlined",
                                    placeholder: _ctx.localeInfo.businessManagerPlaceholder,
                                    "hide-details": ""
                                }, null, 8 /* PROPS */, ["modelValue", "maxlength", "placeholder"])
                            ])
                        ]),
                        _createCommentVNode(" 연락처 "),
                        _createElementVNode("tr", null, [
                            _createElementVNode("td", _hoisted_33, _toDisplayString(_ctx.localeInfo.businessPhone), 1 /* TEXT */),
                            _createElementVNode("td", _hoisted_34, [
                                _createVNode(_component_v_text_field, {
                                    modelValue: _ctx.computedContactTelephone,
                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.computedContactTelephone) = $event)),
                                    maxlength: _ctx.HUB_ADJUSTMENT_TAX_INVOICE_FIELD,
                                    variant: "outlined",
                                    placeholder: _ctx.localeInfo.businessPhonePlaceholder,
                                    "hide-details": ""
                                }, null, 8 /* PROPS */, ["modelValue", "maxlength", "placeholder"])
                            ])
                        ]),
                        _createCommentVNode(" 이메일 "),
                        _createElementVNode("tr", null, [
                            _createElementVNode("td", _hoisted_35, _toDisplayString(_ctx.localeInfo.businessEmail), 1 /* TEXT */),
                            _createElementVNode("td", _hoisted_36, [
                                _createVNode(_component_v_text_field, {
                                    ref: _ctx.formRefs.contactEmail,
                                    modelValue: _ctx.computedContactEmail,
                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_ctx.computedContactEmail) = $event)),
                                    maxlength: _ctx.HUB_ADJUSTMENT_TAX_INVOICE_EMAIL_FIELD,
                                    variant: "outlined",
                                    placeholder: _ctx.localeInfo.businessEmailPlaceholder,
                                    "hide-details": "",
                                    rules: _ctx.formRule.contactEmail.value
                                }, null, 8 /* PROPS */, ["modelValue", "maxlength", "placeholder", "rules"])
                            ])
                        ])
                    ]))
            ]),
            _: 1 /* STABLE */
        }))
        : _createCommentVNode("v-if", true);
}
